<template>
    <v-container grid-list-md fluid>
        <!-- ++ first line -->
        <v-row class="d-flex justify-space-between mb-1" v-if="mode != 'Embedded'">
            <v-col cols="6" class="d-flex flex-column">
                <v-row no-gutters>
                    <v-col cols="1" class="d-flex align-center justify-center">
                        <v-btn-back @click="$router.push({ name: 'auditReport' })" />
                    </v-col>
                    <v-col cols="11" class="d-flex align-center">
                        <h2>Balance &#xe2;gée - Créances échues par date</h2>
                        <v-tooltip location="bottom">
                            <template v-slot:activator="{ props }">
                                <v-btn-icon
                                    v-bind="props"
                                    size="large"
                                    class="ml-2"
                                    icon="$oss-help"
                                />
                            </template>

                            <h2 class="pt-2 pb-1">Ce contrôle permets de nettoyer les comptes</h2>
                            <h2 class="pb-2">
                                et, seulement ensuite, d'afficher la balance &#xe2;gée.
                            </h2>
                            <h4 class="mb-0">
                                Les documents et paiements en attente de validation ou de lettrage
                            </h4>
                            <h4 class="mb-0">ne sont pas pris en compte.</h4>
                            <h2 class="py-2">Procéder dans l'ordre :</h2>
                            <p class="mb-0">Dans "Documents" :</p>
                            <p class="mb-1">
                                - les filtres "A vérifier" et "A vérifier et OK" doivent être vides
                            </p>
                            <p class="mb-0">Dans ce contrôle :</p>
                            <p class="mb-0">
                                - nettoyer le compte 471 (les soldes doivent être nuls)
                            </p>
                            <p class="mb-0">
                                - lettrer les comptes 411 (y compris les lettrages partiels)
                            </p>
                        </v-tooltip>
                    </v-col>
                </v-row>
                <v-row no-gutters>
                    <v-col cols="1" />
                    <v-col cols="10">
                        {{ `Statut : ${checkStatus}` }}
                    </v-col>
                </v-row>
            </v-col>
            <v-col cols="6">
                <v-row no-gutters class="d-flex justify-end align-center">
                    <!-- ** upload -->
                    <v-tooltip location="bottom" text="Lier un document">
                        <template v-slot:activator="{ props }">
                            <v-btn
                                @click="dialogAuditCheckDocumentsManager = true"
                                v-bind="props"
                                size="x-small"
                                icon="$oss-upload"
                                class="mx-1"
                            />
                        </template>
                    </v-tooltip>
                    <!-- ** chat -->
                    <v-tooltip location="bottom" text="Message">
                        <template v-slot:activator="{ props }">
                            <v-btn
                                @click="openChat = !openChat"
                                v-bind="props"
                                size="x-small"
                                icon="$oss-chat"
                                class="mx-1"
                            />
                        </template>
                    </v-tooltip>

                    <!-- ** store -->
                    <v-btn
                        :disabled="
                            closedPeriod || validated || loading || dataLoading || !accountingPeriod
                        "
                        @click="createAdjustmentsData()"
                        size="small"
                        class="mx-1"
                    >
                        Enregistrer
                    </v-btn>

                    <!-- ** validate -->
                    <v-btn
                        :disabled="closedPeriod || loading || dataLoading || !accountingPeriod"
                        @click="validateFunction()"
                        data-cy="CheckReceivablesAgeing-valid"
                        size="small"
                        class="mx-1"
                    >
                        {{ validated ? "Invalider" : "Valider" }}
                    </v-btn>

                    <template v-if="isEnableReview">
                        <div
                            style="
                                border-right: 2px solid black;
                                width: 2px;
                                height: 25px;
                                margin: 0 4px;
                            "
                        />

                        <v-icon
                            :disabled="
                                reviewed === 1 ||
                                !isEnableReview ||
                                !validated ||
                                loading ||
                                dataLoading
                            "
                            size="small"
                            icon="$fa-thumbs-up"
                            color="primary"
                            class="mx-1"
                            @click="
                                reviewed = 1;
                                createAdjustmentsData('REVIEW');
                            "
                        />
                        <v-icon
                            :disabled="
                                reviewed === -1 ||
                                !isEnableReview ||
                                !validated ||
                                loading ||
                                dataLoading
                            "
                            size="small"
                            icon="$fa-thumbs-down"
                            color="primary"
                            class="mx-1"
                            @click="
                                reviewed = -1;
                                createAdjustmentsData('REVIEW');
                            "
                        />

                        <div
                            style="
                                border-right: 2px solid black;
                                width: 1px;
                                height: 25px;
                                margin: 0 4px;
                            "
                        />
                    </template>
                    <v-tooltip location="bottom">
                        <template v-slot:activator="{ props }">
                            <v-btn-prev
                                v-bind="props"
                                :disabled="!previousControl"
                                @click="
                                    reviewed = 0;
                                    openChat = false;
                                    goToPreviousControl();
                                "
                            />
                        </template>
                        <div style="width: 400px" class="d-flex justify-center">
                            Contrôle précédent :
                            {{
                                previousControl && previousControl.title
                                    ? previousControl.title
                                    : ""
                            }}
                        </div>
                    </v-tooltip>
                    <v-tooltip location="bottom">
                        <template v-slot:activator="{ props }">
                            <v-btn-next
                                v-bind="props"
                                @click="
                                    reviewed = 0;
                                    openChat = false;
                                    goToNextControl();
                                "
                                :disabled="!nextControl"
                            />
                        </template>
                        <div style="width: 400px" class="d-flex justify-center">
                            Contrôle suivant :
                            {{ nextControl && nextControl.title ? nextControl.title : "" }}
                        </div>
                    </v-tooltip>
                    <div
                        style="
                            border-right: 2px solid black;
                            width: 1px;
                            height: 25px;
                            margin: 0 4px;
                        "
                    />
                    <v-menu offset-y>
                        <template v-slot:activator="{ props }">
                            <v-btn-icon
                                icon="$dots_vertical"
                                v-bind="props"
                                class="mx-1"
                                color="secondary"
                            />
                        </template>
                        <v-list nav>
                            <v-list-item @click="displayActivityDialog = true">
                                <v-list-item-title>Afficher l'activité</v-list-item-title>
                                <template v-slot:append>
                                    <v-icon>$oss-activity</v-icon>
                                </template>
                            </v-list-item>

                            <template v-if="!showDeleteAcrBtnIfRecovery">
                                <v-tooltip location="bottom">
                                    <template v-slot:activator="{ props }">
                                        <div no-gutters v-bind="props">
                                            <v-list-item no-gutters disabled>
                                                <v-list-item-title>
                                                    Supprimer le contrôle
                                                </v-list-item-title>

                                                <template v-slot:append>
                                                    <v-icon size="small"> $oss-trash </v-icon>
                                                </template>
                                            </v-list-item>
                                        </div>
                                    </template>
                                    <span>{{ showDeleteAcrBtnTooltipMessage }}</span>
                                </v-tooltip>
                            </template>

                            <template v-else>
                                <v-list-item
                                    no-gutters
                                    @click="deleteAuditCheckResultDialog = true"
                                >
                                    <v-list-item-title> Supprimer le contrôle </v-list-item-title>

                                    <template v-slot:append>
                                        <v-icon>$oss-trash</v-icon>
                                    </template>
                                </v-list-item>
                            </template>
                        </v-list>
                    </v-menu>
                </v-row>
            </v-col>
        </v-row>

        <div
            style="
                height: calc(100vh - 157px);
                overflow-y: auto;
                border-top-left-radius: 25px;
                border-top-right-radius: 25px;
            "
        >
            <!-- ++ loading -->
            <template v-if="loading || dataLoading">
                <v-card
                    elevation="0"
                    style="background-color: #ffffff; border-radius: 25px; margin-top: 10px"
                >
                    <v-card-title class="pa-4 d-flex justify-center">
                        <v-progress-circular indeterminate class="mr-3" />
                    </v-card-title>
                </v-card>
            </template>

            <!-- ++ no accountingPeriod -->
            <template v-else-if="!accountingPeriod">
                <v-row no-gutters class="d-flex flex-column justify-center align-center mb-3">
                    <v-icon class="mr-2 mb-1" size="large"> $oss-warning </v-icon>
                    <h3>Aucune période sélectionnée</h3>
                </v-row>
            </template>

            <!-- // ******** GLOBAL AMOUNTS ************************ -->
            <template v-else>
                <v-row
                    no-gutters
                    v-if="closedPeriod"
                    class="d-flex flex-column justify-center align-center mb-3"
                >
                    <v-icon class="mr-2 mb-1" size="large"> $oss-warning </v-icon>
                    <h3>Période clôturée</h3>
                </v-row>

                <v-row no-gutters v-if="!globalAmounts || !globalAmounts.grossAmountSigned">
                    <v-col cols="12" class="d-flex justify-center">
                        <h3>Aucune régularisation enregistrée ou non lettrée</h3>
                    </v-col>
                </v-row>

                <!-- // ** 471 512 -->
                <v-card
                    v-show="show471NL || show471NLNextPeriod"
                    elevation="0"
                    style="background-color: white; border-radius: 25px"
                    class="pa-6 mt-4"
                    v-if="mode != 'Embedded'"
                >
                    <v-row no-gutters>
                        <v-col cols="6" class="d-flex justify-start">
                            <v-card-title class="ma-0 pa-0">
                                <h5 class="pl-4">Grand livre c/471 (paiements non affectés) :</h5>

                                <div class="text-center ma-0">
                                    <v-tooltip location="bottom">
                                        <template v-slot:activator="{ props }">
                                            <v-icon color="primary" v-bind="props" class="ml-2">
                                                $oss-help
                                            </v-icon>
                                        </template>

                                        <h3 class="py-2">Compte 471 :</h3>
                                        <p class="py-0 my-0">
                                            - affecter toutes les écritures de type "Banque"
                                        </p>
                                        <p class="py-0 mt-0">
                                            - ensuite, vérifier que le solde soit nul
                                        </p>
                                    </v-tooltip>
                                </div>
                            </v-card-title>
                        </v-col>

                        <v-col>
                            <v-card-title class="ma-0 pa-0">
                                <v-row
                                    class="d-flex align-center px-4"
                                    no-gutters
                                    :style="colorStyle(totalBalance471NL, 'red')"
                                >
                                    <v-col cols="auto" class="d-flex justify-start">
                                        <h5>Solde N :</h5>
                                    </v-col>

                                    <v-spacer />

                                    <v-col cols="auto" class="d-flex justify-end">
                                        <h5>
                                            {{
                                                newCommonFormatCurrency(
                                                    totalBalance471NL,
                                                    undefined,
                                                )
                                            }}
                                        </h5>
                                    </v-col>
                                </v-row>
                            </v-card-title>
                        </v-col>

                        <v-col cols="2">
                            <v-card-title class="ma-0 pa-0">
                                <v-row
                                    class="d-flex align-center px-4"
                                    no-gutters
                                    :style="colorStyle(totalBalance411NLNextPeriod, 'red')"
                                >
                                    <v-col cols="auto" class="d-flex justify-start">
                                        <h5>Solde N+1 :</h5>
                                    </v-col>

                                    <v-spacer />

                                    <v-col cols="auto" class="d-flex justify-end">
                                        <h5>
                                            {{
                                                newCommonFormatCurrency(
                                                    totalBalance471NLNextPeriod,
                                                    undefined,
                                                )
                                            }}
                                        </h5>
                                    </v-col>
                                </v-row>
                            </v-card-title>
                        </v-col>

                        <!-- <v-spacer></v-spacer> -->

                        <v-col cols="1" />

                        <v-col cols="1" class="d-flex align-center px-0 justify-center">
                            <v-row no-gutters>
                                <v-col cols="6" class="align-center pa-0">
                                    <!-- <v-icon v-if="validated"  class="px-2 pt-1" icon="$check_circle" /> -->
                                </v-col>
                                <v-col cols="6" class="align-center pa-0">
                                    <v-btn-icon
                                        :icon="
                                            generalLedgerExpand
                                                ? '$fa-chevron-up'
                                                : '$fa-chevron-down'
                                        "
                                        @click="generalLedgerExpand = !generalLedgerExpand"
                                        style="width: 40px"
                                        class="d-inline px-2"
                                    />
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>

                    <v-card-text v-show="generalLedgerExpand" transition="expand">
                        <v-card
                            v-for="(period, y) in periods"
                            :key="y"
                            style="background-color: white; border-radius: 25px; padding: 10px"
                            class="pa-2 mt-4"
                        >
                            <v-card-subtitle class="ma-0 pa-0">
                                <h3 class="px-4">Grand livre {{ period.period }}</h3>
                            </v-card-subtitle>

                            <v-card-text>
                                <v-row>
                                    <v-col :key="refreshGeneralLedger471">
                                        <GeneralLedger
                                            :companyId="companyId"
                                            :accountingPeriodId="period.id"
                                            :accountableAccountFilter="['471']"
                                            :inNm1="false"
                                            :hideOptions="true"
                                            :withoutLetteringIfHidedOptions="true"
                                            :hideBodyAppend="true"
                                            @query-done="period.onQueryDone2"
                                            :enableAuditedAccountableAccounts="true"
                                        />
                                        <!-- :accountableAccountFilter="['471', '512']" -->
                                        <!-- :store="true" > default value = false - take options from the store (to avoid in audits) -->
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>
                    </v-card-text>
                </v-card>

                <!-- // ** 411 detailled -->
                <!-- // ** AuditCard : query-done fonctionne seulement si la vielle card suivante est présente -->
                <!-- <AuditCard
                    v-show="show411NL || show411NLNextPeriod"
                    v-if="mode != 'Embedded'"
                    :cardCols="cardCols411"
                    expandContent="generalLedgerExpand411"
                    :validated="false"
                    @query-done="periods[0].onQueryDone"
                >
                    <template #generalLedgerExpand411>
                        <p>periods : {{periods}}</p>
                        <v-card
                            v-for="(period, x) in periods"
                            :key="x"
                            style="background-color: white; border-radius: 25px; padding: 10px"
                            class="my-5"
                        >
                            <v-card-subtitle class="ma-0 pa-0">
                                <h3 class="px-4">Grand livre {{ period.period }}</h3>
                            </v-card-subtitle>

                            <v-card-text>
                                <v-row>
                                    <v-col :key="refreshGeneralLedger411">
                                        <GeneralLedger
                                            :companyId="companyId"
                                            :accountingPeriodId="period.id"
                                            :thirdPartyType="'411'"
                                            :inNm1="false"
                                            :hideOptions="true"
                                            :hideBodyAppend="true"
                                            :withoutLetteringIfHidedOptions="true"
                                            @query-done="testQueryDone(period, $event)"
                                            :enableAuditedAccountableAccounts="true"
                                        /> -->
                <!-- @query-done="period.onQueryDone" -->
                <!-- :store="true" > default value = false - take options from the store (to avoid in audits) -->
                <!-- </v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>
                    </template>
                </AuditCard> -->

                <!-- // ** 411 detailled -->
                <!-- // ** 411 detailled -->
                <v-card
                    v-show="show411NL || show411NLNextPeriod"
                    class="audit-card"
                    v-if="mode != 'Embedded'"
                >
                    <v-row :style="colorStyle(totalBalance411NL, 'red')">
                        <v-col cols="6" class="ma-0 d-flex justify-start align-center py-0">
                            <v-card-title class="d-flex align-center ma-0 pa-0">
                                <h5 class="pl-4 ma-0">
                                    Grand livre c/411 (lettrages à compléter, mouvements à venir en
                                    N+1) :
                                </h5>
                                <v-tooltip location="bottom">
                                    <template v-slot:activator="{ props }">
                                        <v-icon
                                            color="red"
                                            v-bind="props"
                                            class="ml-2"
                                            size="small"
                                        >
                                            $oss-help
                                        </v-icon>
                                    </template>

                                    <span>
                                        La balance &#xe2;gée, afin d'être fiable, nécessite que les
                                        lettrages des comptes clients soyent terminés.
                                    </span>
                                </v-tooltip>
                            </v-card-title>
                        </v-col>

                        <v-spacer />

                        <v-col cols="5" class="ma-0 d-flex align-center">
                            <v-row>
                                <v-col cols="auto" class="ma-0">
                                    <v-card-title class="ma-0 pa-0">
                                        <v-row>
                                            <v-col cols="auto">
                                                <h5 class="pl-4">Solde N :</h5>
                                            </v-col>

                                            <v-col cols="auto">
                                                <h5 class="pl-4">
                                                    {{
                                                        newCommonFormatCurrency(
                                                            totalBalance411NL,
                                                            undefined,
                                                        )
                                                    }}
                                                </h5>
                                            </v-col>
                                        </v-row>
                                    </v-card-title>
                                </v-col>

                                <v-spacer />

                                <v-col cols="auto" class="ma-0">
                                    <v-card-title class="ma-0 pa-0">
                                        <v-row>
                                            <v-col cols="auto">
                                                <h5 class="pl-4">Solde N+1 :</h5>
                                            </v-col>

                                            <v-col cols="auto">
                                                <h5 class="pl-4">
                                                    {{
                                                        newCommonFormatCurrency(
                                                            totalBalance411NLNextPeriod,
                                                            undefined,
                                                        )
                                                    }}
                                                </h5>
                                            </v-col>
                                        </v-row>
                                    </v-card-title>
                                </v-col>
                            </v-row>
                        </v-col>

                        <v-col cols="1" class="d-flex align-center px-0 justify-center">
                            <v-row no-gutters>
                                <v-col cols="6">
                                    <!-- <v-icon v-if="validated"  class="px-2 pt-1" icon="$check_circle" /> -->
                                </v-col>
                                <v-col cols="6" class="align-center pa-0">
                                    <v-btn-icon
                                        :icon="
                                            generalLedgerExpand411
                                                ? '$fa-chevron-up'
                                                : '$fa-chevron-down'
                                        "
                                        data-cy="CheckReceivablesAgeing-grandLivre"
                                        @click="generalLedgerExpand411 = !generalLedgerExpand411"
                                        style="width: 40px"
                                        class="d-inline px-2"
                                    />
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>

                    <v-card-text v-show="generalLedgerExpand411" transition="expand">
                        <v-card
                            v-for="(period, x) in periods"
                            :key="x"
                            style="background-color: white; border-radius: 25px; padding: 10px"
                            class="my-5"
                        >
                            <v-card-subtitle class="ma-0 pa-0">
                                <h3 class="px-4">Grand livre {{ period.period }}</h3>
                            </v-card-subtitle>

                            <v-card-text>
                                <v-row>
                                    <v-col :key="refreshGeneralLedger411">
                                        <GeneralLedger
                                            :companyId="companyId"
                                            :accountingPeriodId="period.id"
                                            :thirdPartyType="'411'"
                                            :inNm1="false"
                                            :hideOptions="true"
                                            :hideBodyAppend="true"
                                            :withoutLetteringIfHidedOptions="true"
                                            @query-done="period.onQueryDone"
                                            :enableAuditedAccountableAccounts="true"
                                        />
                                        <!-- :store="true" > default value = false - take options from the store (to avoid in audits) -->
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>
                    </v-card-text>
                </v-card>

                <v-card
                    elevation="0"
                    style="background-color: white; border-radius: 25px"
                    class="pa-6 mt-4"
                    v-if="showBarchart && formattedBarChartData"
                >
                    <v-card-title class="pt-0 pl-0">
                        <span>Répartition des créances</span>
                    </v-card-title>
                    <v-row no-gutters>
                        <v-col cols="12">
                            <bar-chart
                                :data="formattedBarChartData"
                                :options="barChartOptions"
                                :height="$vuetify.display.mobile ? 200 : 300"
                            />
                        </v-col>
                    </v-row>
                </v-card>

                <!-- // ** customers -->
                <v-card v-if="filteredThirdPartyCompanies.length" class="audit-card">
                    <v-row no-gutters class="d-flex align-center w-100 h-100">
                        <v-col cols="6" class="ma-0 py-0">
                            <v-card-title class="d-flex align-center ma-0 pa-0">
                                <h5 class="pl-4 ma-0">Total créances T.T.C. calculées au :</h5>

                                <v-spacer />
                                <oss-date-picker-filled
                                    v-model="manualSelectedDate"
                                    @update:model-value="
                                        expand = false;
                                        expand4 = false;
                                    "
                                    :textFieldReadOnly="false"
                                    :returnDateStringFormat="'YYYY-MM-DD'"
                                    hide-details
                                    class="px-6"
                                >
                                </oss-date-picker-filled>

                                <v-icon
                                    color="secondary"
                                    class="ml-2"
                                    size="small"
                                    v-tooltip:bottom="
                                        'Afin d\'évaluer les réels impayés et leur ancienneté, la date d\'évaluation des encours est modifiable'
                                    "
                                >
                                    $oss-help
                                </v-icon>
                            </v-card-title>
                        </v-col>

                        <v-col cols="2" class="d-flex align-center">
                            <v-card-title class="ma-0 pa-0">
                                <v-row class="d-flex align-center px-4" no-gutters>
                                    <v-col cols="auto" class="d-flex justify-start">
                                        <h5 class="pr-4">T.T.C. :</h5>
                                    </v-col>

                                    <v-spacer />

                                    <v-col cols="auto" class="d-flex justify-end">
                                        <h5>
                                            {{
                                                newCommonFormatCurrency(
                                                    globalAmounts.grossAmountSigned,
                                                    undefined,
                                                )
                                            }}
                                        </h5>
                                    </v-col>
                                </v-row>
                            </v-card-title>
                        </v-col>

                        <v-col cols="3" />

                        <v-col cols="1" class="d-flex align-center px-0 justify-center">
                            <v-row no-gutters v-if="mode != 'Embedded'">
                                <v-col cols="6" class="d-flex align-center pa-0">
                                    <v-icon
                                        v-if="validated"
                                        color="primary"
                                        size="large"
                                        icon="$check_circle"
                                    />
                                </v-col>
                                <v-col cols="6" class="align-center pa-0">
                                    <v-btn-icon
                                        :icon="
                                            customersExpand ? '$fa-chevron-up' : '$fa-chevron-down'
                                        "
                                        data-cy="CheckReceivablesAgeing-totalCreances"
                                        @click="customersExpand = !customersExpand"
                                        style="width: 40px"
                                        class="d-inline px-2"
                                    />
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>

                    <h4
                        v-if="manualSelectedDate != accountingPeriodEnd"
                        class="text-primary px-4 pb-4"
                    >
                        Attention : les créances sont calculées à la date manuelle et pas à la fin
                        de l'exercice.
                    </h4>

                    <!-- // ************** TABLE OF PERIODS ***************** -->
                    <v-card-text
                        v-show="customersExpand || mode === 'Embedded'"
                        transition="expand"
                        class="mt-0 pt-0"
                    >
                        <v-card
                            v-if="filteredThirdPartyCompanies.length"
                            elevation="0"
                            style="background-color: white; border-radius: 25px"
                            class="py-0 mt-0"
                        >
                            <v-row
                                no-gutters
                                v-if="
                                    globalAmounts.netAmountSigned || globalAmounts.vatAmountSigned
                                "
                            >
                                <v-col cols="3" />

                                <v-col cols="3" class="d-flex justify-start">
                                    <v-card-title class="ma-0 pa-0">
                                        <h6>dont détaillées (factures ou avoirs)</h6>
                                    </v-card-title>
                                </v-col>

                                <v-col cols="2" class="d-flex align-center">
                                    <v-card-title class="ma-0 pa-0">
                                        <v-row class="d-flex align-center px-4" no-gutters>
                                            <v-col cols="auto" class="d-flex justify-start">
                                                <h6 class="pr-4">T.T.C. :</h6>
                                            </v-col>

                                            <v-spacer />

                                            <v-col cols="auto" class="d-flex justify-end">
                                                <h6>
                                                    {{
                                                        newCommonFormatCurrency(
                                                            -(
                                                                globalAmounts.netAmountSigned +
                                                                globalAmounts.vatAmountSigned
                                                            ),
                                                            undefined,
                                                        )
                                                    }}
                                                </h6>
                                            </v-col>
                                        </v-row>
                                    </v-card-title>
                                </v-col>

                                <v-col cols="2">
                                    <v-card-title class="ma-0 pa-0">
                                        <v-row class="d-flex align-center px-4" no-gutters>
                                            <v-col cols="auto" class="d-flex justify-start">
                                                <h6>H.T. :</h6>
                                            </v-col>

                                            <v-spacer />

                                            <v-col cols="auto" class="d-flex justify-end">
                                                <h6>
                                                    {{
                                                        newCommonFormatCurrency(
                                                            Math.abs(globalAmounts.netAmountSigned),
                                                            undefined,
                                                        )
                                                    }}
                                                </h6>
                                            </v-col>
                                        </v-row>
                                    </v-card-title>
                                </v-col>

                                <v-col cols="2">
                                    <v-card-title class="ma-0 pa-0">
                                        <v-row class="d-flex align-center px-4" no-gutters>
                                            <v-col cols="auto" class="d-flex justify-start">
                                                <h6>T.V.A. :</h6>
                                            </v-col>

                                            <v-spacer />

                                            <v-col cols="auto" class="d-flex justify-end">
                                                <h6>
                                                    {{
                                                        newCommonFormatCurrency(
                                                            Math.abs(globalAmounts.vatAmountSigned),
                                                            undefined,
                                                        )
                                                    }}
                                                </h6>
                                            </v-col>
                                        </v-row>
                                    </v-card-title>
                                </v-col>

                                <v-spacer />
                            </v-row>

                            <v-row
                                no-gutters
                                v-if="globalAmounts.importFECAmountSignedTotal"
                                :style="colorStyle(globalAmounts.importFECAmountSignedTotal, 'red')"
                            >
                                <v-col cols="3" />

                                <v-col cols="3" class="d-flex justify-start">
                                    <v-card-title class="ma-0 pa-0">
                                        <h6>dont AN manuels (import FEC)</h6>
                                    </v-card-title>
                                </v-col>

                                <v-col cols="2">
                                    <v-card-title class="d-flex align-center ma-0 pa-0">
                                        <v-row class="d-flex align-center px-4" no-gutters>
                                            <v-col cols="auto" class="d-flex justify-start">
                                                <h6 class="pr-4">T.T.C. :</h6>
                                            </v-col>

                                            <v-spacer />

                                            <v-col cols="auto" class="d-flex justify-end">
                                                <h6>
                                                    {{
                                                        newCommonFormatCurrency(
                                                            globalAmounts.importFECAmountSignedTotal,
                                                            undefined,
                                                        )
                                                    }}
                                                </h6>
                                            </v-col>
                                        </v-row>
                                    </v-card-title>
                                </v-col>

                                <v-spacer />
                            </v-row>

                            <v-row
                                no-gutters
                                v-if="globalAmounts.bankTransactionsAmountSignedTotal"
                                :style="
                                    colorStyle(
                                        globalAmounts.bankTransactionsAmountSignedTotal,
                                        'red',
                                    )
                                "
                            >
                                <v-col cols="3" />

                                <v-col cols="3" class="d-flex justify-start">
                                    <v-card-title class="ma-0 pa-0">
                                        <h6>dont écritures bancaires à lettrer</h6>
                                    </v-card-title>
                                </v-col>

                                <v-col cols="2" class="d-flex align-center">
                                    <v-card-title class="ma-0 pa-0">
                                        <v-row class="d-flex align-center px-4" no-gutters>
                                            <v-col cols="auto" class="d-flex justify-start">
                                                <h6 class="pr-4">T.T.C. :</h6>
                                            </v-col>

                                            <v-spacer />

                                            <v-col cols="auto" class="d-flex justify-end">
                                                <h6>
                                                    {{
                                                        newCommonFormatCurrency(
                                                            globalAmounts.bankTransactionsAmountSignedTotal,
                                                            undefined,
                                                        )
                                                    }}
                                                </h6>
                                            </v-col>
                                        </v-row>
                                    </v-card-title>
                                </v-col>

                                <v-spacer />
                            </v-row>

                            <v-row
                                no-gutters
                                v-if="globalAmounts.more411AlsAmountSignedTotal"
                                :style="
                                    colorStyle(globalAmounts.more411AlsAmountSignedTotal, 'red')
                                "
                            >
                                <v-col cols="3" />

                                <v-col cols="3" class="d-flex justify-start">
                                    <v-card-title class="ma-0 pa-0">
                                        <h6>dont ODs multi clients</h6>
                                    </v-card-title>
                                </v-col>

                                <v-col cols="2" class="d-flex align-center">
                                    <v-card-title class="ma-0 pa-0">
                                        <v-row class="d-flex align-center px-4" no-gutters>
                                            <v-col cols="auto" class="d-flex justify-start">
                                                <h6 class="pr-4">T.T.C. :</h6>
                                            </v-col>

                                            <v-spacer />

                                            <v-col cols="auto" class="d-flex justify-end">
                                                <h6>
                                                    {{
                                                        newCommonFormatCurrency(
                                                            globalAmounts.more411AlsAmountSignedTotal,
                                                            undefined,
                                                        )
                                                    }}
                                                </h6>
                                            </v-col>
                                        </v-row>
                                    </v-card-title>
                                </v-col>

                                <v-spacer />
                            </v-row>

                            <v-card-text class="pa-0 mt-4">
                                <!-- // ** customers periods table -->
                                <v-data-table
                                    :headers="doubtfullAccountsHeaders"
                                    :items="filteredThirdPartyCompanies"
                                    :sort-by="[
                                        { key: 'customer' },
                                        { key: 'netAmountSigned' },
                                        { key: 'grossAmountSigned' },
                                        { key: 'cumulatedCreditNotes' },
                                        { key: 'period31' },
                                        { key: 'period60' },
                                        { key: 'period90' },
                                        { key: 'period120' },
                                        { key: 'period180' },
                                        { key: 'period365' },
                                        { key: 'periodMore' },
                                    ]"
                                    :sort-desc="[false, true]"
                                    :loading="loading"
                                    class="table"
                                    style="border: 1px #ededed solid"
                                >
                                    <template #no-data>Aucune facture échue</template>

                                    <template v-slot:item="props">
                                        <tr>
                                            <!-- // **** Client ******* -->
                                            <td
                                                style="
                                                    font-weight: bold;
                                                    border-right: 1px solid #dddddd;
                                                "
                                            >
                                                {{ props.item.customer.name }}
                                            </td>

                                            <!-- // **** HT total ******* -->
                                            <!-- <td
                                            v-if="props.item.netAmountSigned"
                                            style="font-weight: bold;"
                                            class="text-right"
                                            :style="colorStyleCustomer(props.item, 'red')"
                                        >
                                            {{newCommonFormatCurrency(props.item.netAmountSigned, {currency: ""})}}
                                        </td>
                                        <td v-else class="text-right" :style="colorStyleCustomer(props.item, 'red')">-</td> -->

                                            <!-- // **** TVA totale ******* -->
                                            <!-- <td
                                            v-if="props.item.vatAmountSigned"
                                            style="font-weight: bold;"
                                            class="text-right"
                                            :style="colorStyleCustomer(props.item, 'red')"
                                        >
                                            {{newCommonFormatCurrency(props.item.vatAmountSigned, {currency: ""})}}
                                        </td>
                                        <td v-else class="text-right" :style="colorStyleCustomer(props.item, 'red')">-</td> -->

                                            <!-- // **** sumNotDetailled ******* -->
                                            <!-- <td
                                            v-if="props.item.sumNotDetailled"
                                            style="font-weight: bold;"
                                            class="text-right"
                                            :style="colorStyleCustomer(props.item, 'red')"
                                        >
                                            {{newCommonFormatCurrency(props.item.sumNotDetailled, {currency: ""})}}
                                        </td>
                                        <td v-else class="text-right" :style="colorStyleCustomer(props.item, 'red')">-</td> -->

                                            <!-- // **** Créance TTC totale ******* -->
                                            <td
                                                v-if="props.item.grossAmountSigned"
                                                style="
                                                    font-weight: bold;
                                                    border-right: 1px solid #dddddd;
                                                "
                                                class="text-right"
                                            >
                                                {{
                                                    newCommonFormatCurrency(
                                                        props.item.grossAmountSigned,
                                                        { currency: "" },
                                                    )
                                                }}
                                                <v-btn-icon
                                                    icon="$remove_red_eye"
                                                    :disabled="!props.item.ALs.length"
                                                    @click="
                                                        openPeriodALs(
                                                            props.item.ALs,
                                                            ' : toutes périodes',
                                                            props.item.customer,
                                                        )
                                                    "
                                                    size="x-small"
                                                    color="primary"
                                                />
                                            </td>
                                            <td
                                                v-else
                                                class="text-right pr-8"
                                                style="border-right: 1px solid #dddddd"
                                            >
                                                -
                                            </td>

                                            <!-- // **** < 31 jrs ******* -->
                                            <td
                                                v-if="
                                                    props.item.period31 &&
                                                    props.item.period31.grossAmountSigned
                                                "
                                                class="text-right pr-8"
                                            >
                                                {{
                                                    newCommonFormatCurrency(
                                                        props.item.period31.grossAmountSigned,
                                                        { currency: "" },
                                                    )
                                                }}
                                                <v-btn-icon
                                                    icon="$remove_red_eye"
                                                    :disabled="!props.item.period31.ALs.length"
                                                    @click="
                                                        openPeriodALs(
                                                            props.item.period31.ALs,
                                                            ' - de 31 jrs',
                                                            props.item.customer,
                                                        )
                                                    "
                                                    size="x-small"
                                                    color="primary"
                                                />
                                            </td>
                                            <td v-else class="text-right pr-8">-</td>

                                            <!-- // **** de 32 à 60 jrs ******* -->
                                            <td
                                                v-if="
                                                    props.item.period60 &&
                                                    props.item.period60.grossAmountSigned
                                                "
                                                class="text-right"
                                            >
                                                {{
                                                    newCommonFormatCurrency(
                                                        props.item.period60.grossAmountSigned,
                                                        { currency: "" },
                                                    )
                                                }}
                                                <v-btn-icon
                                                    icon="$remove_red_eye"
                                                    :disabled="!props.item.period60.ALs.length"
                                                    @click="
                                                        openPeriodALs(
                                                            props.item.period60.ALs,
                                                            ' - de 60 jrs',
                                                            props.item.customer,
                                                        )
                                                    "
                                                    size="x-small"
                                                    color="primary"
                                                />
                                            </td>
                                            <td v-else class="text-right pr-8">-</td>

                                            <!-- // **** de 61 à 90 jrs ******* -->
                                            <td
                                                v-if="
                                                    props.item.period90 &&
                                                    props.item.period90.grossAmountSigned
                                                "
                                                class="text-right"
                                            >
                                                {{
                                                    newCommonFormatCurrency(
                                                        props.item.period90.grossAmountSigned,
                                                        { currency: "" },
                                                    )
                                                }}
                                                <v-btn-icon
                                                    icon="$remove_red_eye"
                                                    :disabled="!props.item.period90.ALs.length"
                                                    @click="
                                                        openPeriodALs(
                                                            props.item.period90.ALs,
                                                            ' - de 90 jrs',
                                                            props.item.customer,
                                                        )
                                                    "
                                                    size="x-small"
                                                    color="primary"
                                                />
                                            </td>
                                            <td v-else class="text-right pr-8">-</td>

                                            <!-- // **** de 91 à 120 jrs ******* -->
                                            <td
                                                v-if="
                                                    props.item.period120 &&
                                                    props.item.period120.grossAmountSigned
                                                "
                                                class="text-right"
                                            >
                                                {{
                                                    newCommonFormatCurrency(
                                                        props.item.period120.grossAmountSigned,
                                                        { currency: "" },
                                                    )
                                                }}
                                                <v-btn-icon
                                                    icon="$remove_red_eye"
                                                    :disabled="!props.item.period120.ALs.length"
                                                    @click="
                                                        openPeriodALs(
                                                            props.item.period120.ALs,
                                                            ' - de 120 jrs',
                                                            props.item.customer,
                                                        )
                                                    "
                                                    size="x-small"
                                                    color="primary"
                                                />
                                            </td>
                                            <td v-else class="text-right pr-8">-</td>

                                            <!-- // **** de 121 à 180 jrs ******* -->
                                            <td
                                                v-if="
                                                    props.item.period180 &&
                                                    props.item.period180.grossAmountSigned
                                                "
                                                class="text-right"
                                            >
                                                {{
                                                    newCommonFormatCurrency(
                                                        props.item.period180.grossAmountSigned,
                                                        { currency: "" },
                                                    )
                                                }}
                                                <v-btn-icon
                                                    icon="$remove_red_eye"
                                                    :disabled="!props.item.period180.ALs.length"
                                                    @click="
                                                        openPeriodALs(
                                                            props.item.period180.ALs,
                                                            ' - de 180 jrs',
                                                            props.item.customer,
                                                        )
                                                    "
                                                    size="x-small"
                                                    color="primary"
                                                />
                                            </td>
                                            <td v-else class="text-right pr-8">-</td>

                                            <!-- // **** de 181 à 365 jrs ******* -->
                                            <td
                                                v-if="
                                                    props.item.period365 &&
                                                    props.item.period365.grossAmountSigned
                                                "
                                                class="text-right"
                                            >
                                                {{
                                                    newCommonFormatCurrency(
                                                        props.item.period365.grossAmountSigned,
                                                        { currency: "" },
                                                    )
                                                }}
                                                <v-btn-icon
                                                    icon="$remove_red_eye"
                                                    :disabled="!props.item.period365.ALs.length"
                                                    @click="
                                                        openPeriodALs(
                                                            props.item.period365.ALs,
                                                            ' - de 365 jrs',
                                                            props.item.customer,
                                                        )
                                                    "
                                                    size="x-small"
                                                    color="primary"
                                                />
                                            </td>
                                            <td v-else class="text-right pr-8">-</td>

                                            <!-- // **** > 365 jrs ******* -->
                                            <td
                                                v-if="
                                                    props.item.periodMore &&
                                                    props.item.periodMore.grossAmountSigned
                                                "
                                                class="text-right"
                                                style="border-right: 1px solid #dddddd"
                                            >
                                                {{
                                                    newCommonFormatCurrency(
                                                        props.item.periodMore.grossAmountSigned,
                                                        { currency: "" },
                                                    )
                                                }}
                                                <v-btn-icon
                                                    icon="$remove_red_eye"
                                                    :disabled="!props.item.periodMore.ALs.length"
                                                    @click="
                                                        openPeriodALs(
                                                            props.item.periodMore.ALs,
                                                            ' + de 365 jrs',
                                                            props.item.customer,
                                                        )
                                                    "
                                                    size="x-small"
                                                    color="primary"
                                                />
                                            </td>
                                            <td
                                                v-else
                                                class="text-right pr-8"
                                                style="border-right: 1px solid #dddddd"
                                            >
                                                -
                                            </td>
                                        </tr>
                                    </template>

                                    <template #body.append>
                                        <tr
                                            style="
                                                font-weight: bold;
                                                border-right: 1px solid #dddddd;
                                            "
                                        >
                                            <th>Totaux</th>

                                            <!-- // ** HT -->
                                            <!-- <th style="text-align: right;">
                                            <h3>{{ newCommonFormatCurrency(sumsTable('netAmountSigned'), {currency: ""}) }}</h3>
                                        </th> -->

                                            <!-- // ** TVA -->
                                            <!-- <th style="text-align: right;">
                                            <h3>{{ newCommonFormatCurrency(sumsTable('vatAmountSigned'), {currency: ""}) }}</h3>
                                        </th> -->

                                            <!-- // ** sumNotDetailled -->
                                            <!-- <th style="text-align: right;">
                                            <h3>{{ newCommonFormatCurrency(sumsTable('sumNotDetailled'), {currency: ""}) }}</h3>
                                        </th> -->

                                            <!-- // ** TTC -->
                                            <th
                                                style="
                                                    text-align: right;
                                                    border-right: 1px solid #dddddd;
                                                "
                                            >
                                                <h3 class="pr-8">
                                                    {{
                                                        newCommonFormatCurrency(
                                                            sumsTable("grossAmountSigned"),
                                                            { currency: "" },
                                                        )
                                                    }}
                                                </h3>
                                            </th>

                                            <!-- // ** -31 -->
                                            <th style="text-align: right">
                                                <h3 class="pr-8">
                                                    {{
                                                        newCommonFormatCurrency(
                                                            sumsTable2(
                                                                "period31",
                                                                "grossAmountSigned",
                                                            ),
                                                            { currency: "" },
                                                        )
                                                    }}
                                                </h3>
                                            </th>

                                            <!-- // ** -60 -->
                                            <th style="text-align: right">
                                                <h3 class="pr-8">
                                                    {{
                                                        newCommonFormatCurrency(
                                                            sumsTable2(
                                                                "period60",
                                                                "grossAmountSigned",
                                                            ),
                                                            { currency: "" },
                                                        )
                                                    }}
                                                </h3>
                                            </th>

                                            <!-- // ** -90 -->
                                            <th style="text-align: right">
                                                <h3 class="pr-8">
                                                    {{
                                                        newCommonFormatCurrency(
                                                            sumsTable2(
                                                                "period90",
                                                                "grossAmountSigned",
                                                            ),
                                                            { currency: "" },
                                                        )
                                                    }}
                                                </h3>
                                            </th>

                                            <!-- // ** -120 -->
                                            <th style="text-align: right">
                                                <h3 class="pr-8">
                                                    {{
                                                        newCommonFormatCurrency(
                                                            sumsTable2(
                                                                "period120",
                                                                "grossAmountSigned",
                                                            ),
                                                            { currency: "" },
                                                        )
                                                    }}
                                                </h3>
                                            </th>

                                            <!-- // ** -180 -->
                                            <th style="text-align: right">
                                                <h3 class="pr-8">
                                                    {{
                                                        newCommonFormatCurrency(
                                                            sumsTable2(
                                                                "period180",
                                                                "grossAmountSigned",
                                                            ),
                                                            { currency: "" },
                                                        )
                                                    }}
                                                </h3>
                                            </th>

                                            <!-- // ** -365 -->
                                            <th style="text-align: right">
                                                <h3 class="pr-8">
                                                    {{
                                                        newCommonFormatCurrency(
                                                            sumsTable2(
                                                                "period365",
                                                                "grossAmountSigned",
                                                            ),
                                                            { currency: "" },
                                                        )
                                                    }}
                                                </h3>
                                            </th>

                                            <!-- // ** >365 -->
                                            <th style="text-align: right">
                                                <h3>
                                                    {{
                                                        newCommonFormatCurrency(
                                                            sumsTable2(
                                                                "periodMore",
                                                                "grossAmountSigned",
                                                            ),
                                                            { currency: "" },
                                                        )
                                                    }}
                                                </h3>
                                            </th>
                                        </tr>
                                    </template>
                                </v-data-table>

                                <!-- // ** btns OD + Enregistrer + Valider -->
                                <v-row no-gutters v-if="mode != 'Embedded'">
                                    <v-col style="padding-bottom: 0">
                                        <v-card-title
                                            style="
                                                padding-top: 20px;
                                                padding-bottom: 0;
                                                padding-left: 0;
                                            "
                                            class="d-flex justify-end"
                                        >
                                            <v-spacer />

                                            <!-- // ** OD -->
                                            <v-btn
                                                :disabled="closedPeriod || validated"
                                                rounded
                                                class="btn btn_blue"
                                                @click="
                                                    createAdjustmentsData();
                                                    miscellanousOperationData = undefined;
                                                    miscellaneousOperationDialog = true;
                                                "
                                                size="small"
                                            >
                                                OD
                                            </v-btn>

                                            <!-- // ** Store data -->
                                            <v-btn
                                                :disabled="closedPeriod || validated"
                                                rounded
                                                class="btn btn_blue ml-2"
                                                @click.stop="createAdjustmentsData()"
                                                size="small"
                                            >
                                                Enregistrer
                                            </v-btn>

                                            <!-- // ** validate -->
                                            <v-btn
                                                v-if="closedPeriod"
                                                rounded
                                                class="btn btn_blue ml-2"
                                                disabled
                                                size="small"
                                            >
                                                Valider
                                            </v-btn>

                                            <v-btn
                                                rounded
                                                class="btn btn_blue ml-2"
                                                @click="
                                                    validated = !validated;
                                                    adjustmentsExpand = false;
                                                    createAdjustmentsData(
                                                        !validated ? 'VALIDATE' : 'UPDATE',
                                                    );
                                                "
                                                size="small"
                                            >
                                                {{ !validated ? "Valider" : "Invalider" }}
                                            </v-btn>
                                        </v-card-title>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>
                    </v-card-text>
                </v-card>

                <!-- // ************** DOCUMENTS LIST / PERIODS ******************* -->
                <v-card
                    elevation="0"
                    style="background-color: white; border-radius: 25px"
                    class="pa-6 mt-4"
                    v-if="periodDocuments.length > 0"
                    v-show="expand"
                >
                    <v-expand-transition>
                        <v-card-text v-if="periodDocuments.length > 0" v-show="expand" class="pa-0">
                            <v-row class="px-5 pt-3">
                                <v-col>
                                    <h3>
                                        {{ periodsCustomer.name }} - Factures échues depuis
                                        {{ selectedPeriod }}
                                    </h3>
                                </v-col>
                            </v-row>

                            <v-card-text class="py-4">
                                <!-- <p>periodDocuments : {{periodDocuments}}</p> -->
                                <v-data-table
                                    :headers="periodDocumentsHeaders"
                                    :items="periodDocuments"
                                    :sort-by="[
                                        { key: 'date' },
                                        { key: 'netAmountSigned' },
                                        { key: 'grossAmountSigned' },
                                        { key: 'dueDate' },
                                        { key: 'name' },
                                    ]"
                                    :loading="loading"
                                    class="table"
                                    style="border: 1px #ededed solid"
                                >
                                    <template #no-data
                                        >Aucune facture échue sur la période</template
                                    >

                                    <template v-slot:item="props">
                                        <tr>
                                            <!-- // *** Type *** -->
                                            <td v-if="props.item.docType" class="text-left">
                                                {{
                                                    $t("accountingItem.type." + props.item.docType)
                                                }}
                                            </td>
                                            <td v-else class="text-center">-</td>

                                            <!-- // *** Date *** -->
                                            <td v-if="props.item.date" class="text-center">
                                                {{ formatDate(props.item.date) }}
                                            </td>
                                            <td v-else class="text-center">-</td>

                                            <!-- // *** text *** -->
                                            <td class="text-left">
                                                {{ props.item.wording || "-" }}
                                            </td>

                                            <!-- // *** invoiceNumber *** -->
                                            <td class="text-left">
                                                {{ props.item.invoiceNumber || "-" }}
                                            </td>

                                            <!-- // *** netAmountSigned *** -->
                                            <td class="text-right">
                                                {{
                                                    newCommonFormatCurrency(
                                                        props.item.doc7and6 || 0,
                                                        { currency: "" },
                                                    )
                                                }}
                                            </td>

                                            <!-- // *** vatAmountSigned *** -->
                                            <td class="text-right">
                                                {{
                                                    newCommonFormatCurrency(
                                                        props.item.doc445 || 0,
                                                        { currency: "" },
                                                    )
                                                }}
                                            </td>

                                            <!-- // *** grossAmountSigned *** -->
                                            <td class="text-right">
                                                {{
                                                    newCommonFormatCurrency(
                                                        props.item.amountSigned || 0,
                                                        { currency: "" },
                                                    )
                                                }}
                                            </td>

                                            <!-- // *** dueDate *** -->
                                            <td v-if="props.item.dueDate" class="text-center">
                                                {{ formatDate(props.item.dueDate) }}
                                            </td>
                                            <td v-else class="text-center">-</td>

                                            <!-- // *** openObject *** -->
                                            <td class="text-center pl-2 py-0">
                                                <v-btn-icon
                                                    icon="$remove_red_eye"
                                                    @click="
                                                        openObject(props.item.id, props.item.type)
                                                    "
                                                    color="primary"
                                                />
                                            </td>
                                        </tr>
                                    </template>
                                </v-data-table>
                            </v-card-text>
                        </v-card-text>
                    </v-expand-transition>
                </v-card>
                <AuditConnectedAcrDocuments
                    v-if="mode != 'Embedded'"
                    :connectedDocuments="connectedDocuments"
                    :companyId="companyId"
                    :acKey="acKey"
                    :auditCheckResult="auditCheckResult || {}"
                    :accountingPeriodId="accountingPeriodId || undefined"
                    @unlinkedDocument="unlinkDocument($event)"
                    @showLinkedDocument="showLinkedDocument($event)"
                />

                <template v-if="!loading && !dataLoading && mode != 'Embedded'">
                    <AuditConnectedAcrResults :results="results" :companyId="companyId" />
                </template>

                <!-- // ** long comments -->
                <v-card
                    v-if="mode != 'Embedded'"
                    elevation="0"
                    style="background-color: white; border-radius: 25px"
                    class="pa-6 mt-4"
                >
                    <v-row no-gutters>
                        <v-col cols="5" class="ma-auto">
                            <v-card-title class="ma-0 pa-0">
                                <h5 class="pl-4">Commentaires détaillés</h5>
                            </v-card-title>
                        </v-col>

                        <v-spacer />

                        <v-col cols="1" class="d-flex align-center px-0 justify-center">
                            <v-row no-gutters>
                                <v-col cols="6" class="align-center pa-0">
                                    <!-- <v-icon v-if="validated"  class="px-2 pt-1" icon="$check_circle" /> -->
                                </v-col>
                                <v-col cols="6" class="align-center pa-0">
                                    <v-btn-icon
                                        :icon="
                                            commentExpand ? '$fa-chevron-up' : '$fa-chevron-down'
                                        "
                                        data-cy="CheckReceivablesAgeing-commantairesDetailles"
                                        @click="commentExpand = !commentExpand"
                                        style="width: 40px"
                                        class="d-inline px-2"
                                    />
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>

                    <v-card-text v-if="commentExpand" transition="expand">
                        <v-row class="pt-6">
                            <v-col style="padding-top: 0">
                                <v-card-text style="padding: 0">
                                    <v-textarea
                                        v-model="comment"
                                        :disabled="closedPeriod || validated"
                                        auto-grow
                                        style="border: 1px #ededed solid"
                                        outlined
                                    />
                                    <!-- :key="i" -->
                                </v-card-text>
                            </v-col>
                        </v-row>

                        <v-row no-gutters>
                            <v-col style="padding-bottom: 0">
                                <v-card-title
                                    style="padding-top: 20px; padding-bottom: 0; padding-left: 0"
                                    class="d-flex justify-end"
                                >
                                    <v-spacer />

                                    <!-- // ** OD -->
                                    <v-btn
                                        v-if="closedPeriod || validated"
                                        rounded
                                        disabled
                                        size="small"
                                    >
                                        OD
                                    </v-btn>

                                    <v-btn
                                        v-else
                                        rounded
                                        class="btn btn_blue"
                                        @click="
                                            createAdjustmentsData();
                                            miscellanousOperationData = undefined;
                                            miscellaneousOperationDialog = true;
                                        "
                                        size="small"
                                    >
                                        OD
                                    </v-btn>

                                    <!-- // ** Store data -->
                                    <v-btn
                                        v-if="closedPeriod || validated"
                                        disabled
                                        rounded
                                        class="btn btn_blue ml-2"
                                        size="small"
                                    >
                                        Enregistrer
                                    </v-btn>
                                    <v-btn
                                        v-else
                                        rounded
                                        class="btn btn_blue ml-2"
                                        @click.stop="createAdjustmentsData()"
                                        size="small"
                                    >
                                        Enregistrer
                                    </v-btn>

                                    <!-- // ** validate -->
                                    <v-btn
                                        v-if="closedPeriod"
                                        rounded
                                        class="btn btn_blue ml-2"
                                        disabled
                                        size="small"
                                    >
                                        Valider
                                    </v-btn>
                                    <v-btn
                                        v-else-if="!validated"
                                        rounded
                                        class="btn btn_blue ml-2"
                                        @click="
                                            validated = !validated;
                                            adjustmentsExpand = false;
                                            createAdjustmentsData('VALIDATE');
                                        "
                                        size="small"
                                    >
                                        Valider
                                    </v-btn>
                                    <v-btn
                                        v-else
                                        rounded
                                        class="btn btn_blue ml-2"
                                        @click="
                                            validated = !validated;
                                            createAdjustmentsData('UPDATE');
                                        "
                                        size="small"
                                    >
                                        Invalider
                                    </v-btn>
                                </v-card-title>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>

                <!-- // ** shortComment -->
                <v-card
                    elevation="0"
                    style="background-color: white; border-radius: 25px"
                    class="pa-6 mt-4"
                    v-if="mode != 'Embedded'"
                >
                    <v-row no-gutters>
                        <v-col cols="5" class="ma-0">
                            <v-card-title class="ma-0 pa-0">
                                <h5 class="pl-4">Commentaires synthétiques</h5>
                            </v-card-title>
                        </v-col>

                        <v-spacer />

                        <v-col cols="1" class="d-flex align-center px-0 justify-center">
                            <v-row no-gutters>
                                <v-col cols="6" class="align-center pa-0">
                                    <!-- <v-icon v-if="validated"  class="px-2 pt-1" icon="$check_circle" /> -->
                                </v-col>
                                <v-col cols="6" class="align-center pa-0">
                                    <v-btn-icon
                                        :icon="
                                            shortCommentExpand
                                                ? '$fa-chevron-up'
                                                : '$fa-chevron-down'
                                        "
                                        data-cy="CheckReceivablesAgeing-commentairesSynthetiques"
                                        @click="shortCommentExpand = !shortCommentExpand"
                                        style="width: 40px"
                                        class="d-inline px-2"
                                    />
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>

                    <v-card-text v-if="shortCommentExpand" transition="expand">
                        <v-row class="pt-6">
                            <v-col style="padding-top: 0">
                                <v-card-text style="padding: 0">
                                    <v-textarea
                                        v-model="shortComment"
                                        :disabled="closedPeriod || validated"
                                        auto-grow
                                        style="border: 1px #ededed solid"
                                        outlined
                                    />
                                    <!-- :key="i" -->
                                </v-card-text>
                            </v-col>
                        </v-row>

                        <v-row no-gutters>
                            <v-col style="padding-bottom: 0">
                                <v-card-title
                                    style="padding-top: 20px; padding-bottom: 0; padding-left: 0"
                                    class="d-flex justify-end"
                                >
                                    <v-spacer />

                                    <!-- // ** OD -->
                                    <v-btn
                                        v-if="closedPeriod || validated"
                                        rounded
                                        disabled
                                        size="small"
                                    >
                                        OD
                                    </v-btn>

                                    <v-btn
                                        v-else
                                        rounded
                                        class="btn btn_blue"
                                        @click="
                                            createAdjustmentsData();
                                            miscellanousOperationData = undefined;
                                            miscellaneousOperationDialog = true;
                                        "
                                        size="small"
                                    >
                                        OD
                                    </v-btn>

                                    <!-- // ** Store data -->
                                    <v-btn
                                        v-if="closedPeriod || validated"
                                        disabled
                                        rounded
                                        class="btn btn_blue ml-2"
                                        size="small"
                                    >
                                        Enregistrer
                                    </v-btn>
                                    <v-btn
                                        v-else
                                        rounded
                                        class="btn btn_blue ml-2"
                                        @click.stop="createAdjustmentsData()"
                                        size="small"
                                    >
                                        Enregistrer
                                    </v-btn>

                                    <!-- // ** validate -->
                                    <v-btn
                                        v-if="closedPeriod"
                                        rounded
                                        class="btn btn_blue ml-2"
                                        disabled
                                        size="small"
                                    >
                                        Valider
                                    </v-btn>
                                    <v-btn
                                        v-else-if="!validated"
                                        rounded
                                        class="btn btn_blue ml-2"
                                        @click="
                                            validated = !validated;
                                            adjustmentsExpand = false;
                                            createAdjustmentsData('VALIDATE');
                                        "
                                        size="small"
                                    >
                                        Valider
                                    </v-btn>
                                    <v-btn
                                        v-else
                                        rounded
                                        class="btn btn_blue ml-2"
                                        @click="
                                            validated = !validated;
                                            createAdjustmentsData('UPDATE');
                                        "
                                        size="small"
                                    >
                                        Invalider
                                    </v-btn>
                                </v-card-title>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
                <oss-dialog
                    v-model="displayActivityDialog"
                    v-if="displayActivityDialog"
                    title="Activité"
                    valid-title="Fermer"
                    @valid="displayActivityDialog = false"
                    @close="displayActivityDialog = false"
                    min-width="60vw"
                >
                    <UsersActivitiesHistory
                        :auditCheckKey="acKey"
                        :accountingPeriodId="accountingPeriodId"
                    >
                    </UsersActivitiesHistory>
                </oss-dialog>
                <!-- <AccountingItemEdition
                    v-model="miscellaneousOperationDialog"
                    :companyId="companyId"
                    :prefilledRows="miscellanousOperationData"

                    :acKey="acKey"
                    :auditCheckResult="auditCheckResult"
                    :accountingPeriodId="accountingPeriodId"
                    @upsert="refresh()"
                    v-if="miscellaneousOperationDialog"
                ></AccountingItemEdition> -->
                <oss-dialog
                    v-model="miscellaneousOperationDialog"
                    :actions="actionsMiscellaneousOperation"
                    min-width="90vw"
                >
                    <AccountingItemEdition2
                        v-if="miscellaneousOperationDialog"
                        :companyId="companyId"
                        :prefilledRows="miscellanousOperationData"
                        :acKey="acKey"
                        :auditCheckResult="auditCheckResult"
                        :accountingPeriodId="accountingPeriodId"
                        @upsertedAuditCheckResult="refresh()"
                        :actions="actionsMiscellaneousOperation"
                    />
                </oss-dialog>
                <Chat
                    :auditCheckAccountingPeriodKey="chatId"
                    v-if="openChat"
                    v-bind:chatTitle="'Chat'"
                />
                <AuditCheckDocumentsManager
                    v-model="dialogAuditCheckDocumentsManager"
                    v-if="dialogAuditCheckDocumentsManager"
                    :disabled="loading || dataLoading || !accountingPeriod"
                    :companyId="companyId"
                    :documentToDisplay="documentToDisplay"
                    :connectedDocuments="connectedDocuments || []"
                    :acKey="acKey"
                    :auditCheckResult="auditCheckResult || {}"
                    :accountingPeriodId="accountingPeriodId || undefined"
                    :alreadyLinkedDoc="alreadyLinkedDoc"
                    @upsertedAuditCheckResult="upsertedACR"
                    @resetDialogData="
                        alreadyLinkedDoc = false;
                        documentToDisplay = {};
                    "
                />
                <!-- :accountingItemType="'MISCELLANEOUS_OPERATION'" -->
            </template>

            <!-- ++ deleteAuditCheckResultDialog -->
            <template v-if="deleteAuditCheckResultDialog">
                <AuditDeleteAuditCheckResultDialog
                    v-model="deleteAuditCheckResultDialog"
                    :auditCheckResultId="auditCheckResultId"
                    @closed="
                        deleteAuditCheckResultLoading = false;
                        deleteAuditCheckResultDialog = false;
                    "
                    @deletedAcr="deleteAcrDone"
                />
                <!-- deleteAuditCheckResultLoading="deleteAuditCheckResultLoading" -->
            </template>
        </div>
    </v-container>
</template>

<script lang="ts">
import moment from "moment-timezone";
import { Apollo } from "@/decorators";
import { mathFix } from "../../services/mathServices";
import { newCommonFormatCurrency } from "../../../../backend/src/common/services/mathServices";
import { isEmpty, cloneDeep } from "lodash";
import { closedPeriod } from "../../services/audit/AuditServices";

import AccountingItemEdition2 from "../accounting/accountingItem/Edition.vue";
import GeneralLedger from "../GeneralLedger2.vue";
import AuditCheckDocumentsManager from "./AuditCheckDocumentsManager.vue";
import AuditConnectedAcrDocuments from "./AuditConnectedAcrDocuments.vue";
import Chat from "../chat/Chat.vue";
import AuditConnectedAcrResults from "./AuditConnectedAcrResults.vue";
import UsersActivitiesHistory from "../UsersActivitiesHistory.vue";
import AuditDeleteAuditCheckResultDialog from "./AuditDeleteAuditCheckResultDialog.vue";
import AuditCard from "./AuditCard.vue";

// //////////////////// APOLLO ////////////////////////
import AUDIT_ITEMS from "../../graphql/audit/AuditItems.gql";
import UPSERT_AUDIT_CHECK_RESULT from "../../graphql/audit/UpsertAuditCheckResultClosure.gql";

import { CheckBase } from "./CheckBase";
import { getDBFormattedEndDate } from "@/services/dateServices";
import { DialogAction } from "@/services/dialogAction";
import { chartColors } from "../../../../backend/src/common/chart/graphServices";
import { Bar as BarChart } from "vue-chartjs";
import { Component, Vue, Watch, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";

@Component({
    components: {
        GeneralLedger,
        AuditCheckDocumentsManager,
        AuditConnectedAcrDocuments,
        Chat,
        AuditConnectedAcrResults,
        UsersActivitiesHistory,
        AuditDeleteAuditCheckResultDialog,
        AccountingItemEdition2,
        BarChart,
        AuditCard,
    },
})
export class CheckReceivablesAgeing extends CheckBase {
    @Prop({ type: Boolean }) readonly active!: Boolean;
    @Prop({ default: "" }) documentId: string;
    @Prop({ default: "" }) mode: string;
    @Prop({ default: "" }) inSelectedDate: string;
    @Prop({ default: null }) inFilteredThirdPartyCompanies: any;
    @Prop({ default: false }) showBarchart: boolean;

    loading: boolean = false;
    dataLoading: boolean = true;
    deleteAuditCheckResultLoading: boolean = false;

    dialogAuditCheckDocumentsManager: boolean = false;
    deleteAuditCheckResultDialog: boolean = false;

    customersExpand: boolean = false;

    company: any = {};

    firstOpenPeriodStart: string = "";
    lastOpenPeriodEnd: string = "";
    nextAccountingPeriod: any = {};
    periods: Array<any> = [];

    // auditCheckKey: string = "E0203ayUPxB5dyvLb0OovyHY"
    auditCheckResult: any = null;
    auditCheckResultId = "";

    noResults: boolean = false;
    // currentDocumentData: Array<any> = []
    // currentDocACRid: string = ""
    // currentDocACR: any = null
    // previousDocumentsIds: Array<any> = [];
    resultDocumentIdsToDelete: Array<any> = [];
    validated: boolean = false;
    comment: string = "";
    shortComment: string = "";

    alreadyLinkedDoc: boolean = false;

    // searchCustomer = ""

    // // +++++++++++ RESET +++++++++++++++++
    // defaultFilter() {
    //     this.searchCustomer = "";
    // }

    // @Watch("searchCustomer")
    // onFilterChanged() {
    //     this.chatsPagination.page = 1;
    // }

    creditNoteDialog: boolean = false;

    show: boolean = false;

    show411NL: boolean = false;
    show411NLNextPeriod: boolean = false;

    show471NL: boolean = false;
    show471NLNextPeriod: boolean = false;

    expand: boolean = false;
    expand4: boolean = false;
    adjustmentsExpand: boolean = false;

    commentExpand: boolean = false;
    shortCommentExpand: boolean = false;

    generalLedgerExpand: boolean = false;
    generalLedgerExpand411: boolean = false;

    showGeneralLedger: boolean = false;
    showGeneralLedger411: boolean = false;

    accountableAccountFilter: Array<any> = ["411"];

    totalBalance411NL: Number = 0;
    totalBalance411NLNextPeriod: Number = 0;

    totalBalance471NL: Number = 0;
    totalBalance471NLNextPeriod: Number = 0;

    refreshGeneralLedger471: number = 1;
    refreshGeneralLedger411: number = 1;

    miscellaneousOperationDialog: boolean = false;
    miscellanousOperationData: Array<any> = [];

    selectedCustomer: any = {};

    manualSelectedDate: string = "";
    accountingPeriodEnd: string = "";
    minDate: string = "";
    maxDate: string = "";

    // periodYear: string = ""
    // invoicesNotToPay: Array<any> = []

    creditNote: any = {};
    creditNotes: Array<any> = [];
    existingCreditNotes: Array<any> = [];

    globalCreditNoteNetAmount: number = 0.0;
    globalCreditNoteVatAmount: number = 0.0;
    globalCreditNoteVatRate: number = 0.0;
    calculatedVatRate: number = 0.0;
    globalCreditNoteGrossAmount: number = 0.0;

    invoiceNumber: string = "";

    accountingTransactions: Array<any> = [];
    withoutLettering: boolean = false;
    withoutBank: boolean = false;
    withoutDocument: boolean = false;

    connectedDocuments: Array<any> = [];
    results: Array<any> = [];
    documentToDisplay: any = {};

    showDeleteAcrBtnTooltipMessage: string = "";

    actionsMiscellaneousOperation = {
        action: new DialogAction(),
    };

    newCommonFormatCurrency(value, options = undefined) {
        return newCommonFormatCurrency(value, undefined);
    }

    expanded: boolean = false;

    toggleExpand() {
        this.expanded = !this.expanded;
    }

    get selectedDate() {
        if (this.inSelectedDate && this.manualSelectedDate === "") {
            // ** @Prop : coming from Outstanding.vue
            return this.inSelectedDate;
        }
        if (this.manualSelectedDate) {
            // ** date-picker
            return this.formatDatePicker(this.manualSelectedDate);
        }
        return this.formatDatePicker(this.accountingPeriod.end);
    }

    get selectedCompany() {
        return this.$store.state.selected_company;
    }

    get checkStatus() {
        if (this.validated && this.reviewed === 1) {
            return "Validé par le responsable";
        }
        if (this.validated && this.reviewed === -1) {
            return "Refusé par le responsable";
        }
        if (this.validated && this.reviewed === 0) {
            return "En attente de validation par le responsable";
        }
        if (!this.validated && !this.auditCheckResult) {
            return "A faire";
        }
        if (!this.validated && this.auditCheckResult) {
            return "En cours";
        }
        return "statut manquant";
    }

    get showDeleteAcrBtnIfRecovery() {
        if (this.auditCheckResultId) {
            if (this.closedPeriod) {
                this.showDeleteAcrBtnTooltipMessage = "Exercice N clôturé";
                return false;
            }
            return true;
        }
        this.showDeleteAcrBtnTooltipMessage = "Aucun contrôle";
        return false;
    }

    @Watch("totalBalance411NL")
    onTotalBalance411NLChanged() {
        this.cardCols411[1].nestedRows[0].nestedCols[1].amount = this.totalBalance411NL || 0;
    }

    @Watch("totalBalance411NLNextPeriod")
    onTotalBalance411NLNextPeriodChanged() {
        this.cardCols411[2].nestedRows[0].nestedCols[1].amount =
            this.totalBalance411NLNextPeriod || 0;
    }

    @Watch("totalBalance471NL")
    onTotalBalance471NLChanged() {
        debugger;
        // -- todo
        // this.cardCols471[1].nestedRows[0].nestedCols[1].amount = this.totalBalance471NL || 0;
    }

    @Watch("totalBalance471NLNextPeriod")
    onTotalBalance471NLNextPeriodChanged() {
        debugger;
        // -- todo
        // this.cardCols471[2].nestedRows[0].nestedCols[1].amount = this.totalBalance471NLNextPeriod || 0;
    }

    // get companyId() {
    //     return this.$store.state.selected_company.id
    // }

    // get company() {
    //     return this.$store.state.selected_company
    // }

    // get accountingPeriodId() {
    //     return this.$store.state.accountingPeriod.selectedAccountingPeriod ?  this.$store.state.accountingPeriod.selectedAccountingPeriod.id : '';
    // }

    // get accountingPeriod() {
    //     return this.$store.state.accountingPeriod.selectedAccountingPeriod ? this.$store.state.accountingPeriod.selectedAccountingPeriod : '';
    // }

    // ++++ The DatePicker needs a format 'YYYY-MM-DD' +++++
    formatDatePicker(date: string) {
        return moment(date).format("YYYY-MM-DD");
    }

    formatDate(date: string) {
        return moment(date).format("DD/MM/YYYY");
    }

    cardCols411: Array<any> = [
        {
            cols: 7,
            props: { class: "" },
            nestedRows: [
                {
                    nestedCols: [
                        {
                            cols: 10,
                            component: "h4",
                            props: { class: "text-red" },
                            content:
                                "Grand livre c/411 (lettrages à compléter, mouvements à venir en N+1) :",
                        },
                        {
                            cols: 2,
                            component: "v-tooltip",
                            props: { color: "red" },
                            content:
                                "La balance âgée, afin d'être fiable, nécessite que les lettrages des comptes clients soyent terminés.",
                        },
                    ],
                },
            ],
        },
        {
            cols: 2,
            props: { class: "" },
            nestedRows: [
                {
                    nestedCols: [
                        {
                            cols: 6,
                            component: "h4",
                            props: { class: "text-red" },
                            content: "Solde N :",
                        },
                        {
                            cols: 6,
                            component: "h4",
                            props: { class: "text-red" },
                            amount: this.totalBalance411NL || 0,
                        },
                    ],
                },
            ],
        },
        {
            cols: 2,
            nestedRows: [
                {
                    nestedCols: [
                        {
                            cols: 6,
                            component: "h4",
                            props: { class: "text-red" },
                            content: "Solde N+1 :",
                        },
                        {
                            cols: 6,
                            component: "h4",
                            props: { class: "text-red" },
                            amount: this.totalBalance411NLNextPeriod || 0,
                        },
                    ],
                },
            ],
        },
    ];

    // ********** HEADERS - DUES SALES-INVOICES ***********
    // from back

    // ********** HEADERS - LIST OF SALES-INVOICES / DUE PERIOD ***********
    periodDocumentsHeaders: Array<any> = [
        {
            title: "Type",
            value: "docType",
            align: "left",
            sortable: true,
        },
        {
            title: "Date",
            value: "date",
            align: "center",
            sortable: true,
        },
        {
            title: "Libellé",
            value: "name",
            align: "left",
            sortable: true,
        },
        {
            title: "N. de facture",
            value: "invoiceNumber",
            align: "left",
            sortable: true,
        },
        {
            title: "HT",
            value: "netAmountSigned",
            align: "right",
            sortable: true,
        },
        {
            title: "TVA totale",
            value: "vatAmountSigned",
            align: "right",
            sortable: true,
        },
        {
            title: "TTC",
            value: "grossAmountSigned",
            align: "right",
            sortable: true,
        },
        {
            title: "Echéance",
            value: "dueDate",
            align: "center",
            sortable: true,
        },
        {
            title: "Voir le document",
            value: "",
            align: "center",
            sortable: true,
        },
    ];

    // ********** HEADERS - LIST OF PREVIOUS CREDIT NOTES ***********
    creditNotesListHeaders: Array<any> = [
        {
            title: "Date avoir",
            value: "date",
            align: "center",
            sortable: true,
        },
        {
            title: "Libellé",
            value: "name",
            align: "left",
            sortable: true,
        },
        {
            title: "HT",
            value: "netAmount",
            align: "right",
            sortable: true,
        },
        {
            title: "TVA",
            value: "vatAmount",
            align: "right",
            sortable: true,
        },
        {
            title: "TTC",
            value: "grossAmount",
            align: "right",
            sortable: true,
        },
    ];

    // ********** HEADERS - LIST OF PREVIOUS CREDIT NOTES ***********
    detailedCreditNotesHeaders: Array<any> = [
        {
            title: "Date facture",
            value: "date",
            align: "center",
            sortable: true,
        },
        {
            title: "Numéro facture",
            value: "",
            align: "center",
            sortable: true,
        },
        {
            title: "Client",
            value: "thirdPartyCompany",
            align: "left",
            sortable: true,
        },
        {
            title: "HT",
            value: "netAmount",
            align: "right",
            sortable: true,
        },
        {
            title: "TVA",
            value: "vatAmount",
            align: "right",
            sortable: true,
        },
        {
            title: "TTC",
            value: "grossAmount",
            align: "right",
            sortable: true,
        },
    ];

    beforeMount() {
        this._mounted();
        this.searchAccountingPeriod();
    }

    afterAccountingPeriodFound() {
        if (this.accountingPeriodId && this.accountingPeriod) {
            this.periods.push({
                period: "N",
                id: this.accountingPeriodId,
                onQueryDone: (data) => {
                    this.onQueryDone411NL(data);
                },
                onQueryDone2: (data) => {
                    this.onQueryDone471NL(data);
                },
            });
            // this.accountingPeriod = this.accountingPeriods.find(ap => ap.id === this.accountingPeriodId)
            if (this.accountingPeriod?.end) {
                this.accountingPeriodEnd = this.formatDatePicker(this.accountingPeriod.end);
                // this.manualSelectedDate = this.formatDatePicker(this.accountingPeriod.end); // ** date-picker : have to be empty for @Apollo
                const nextAccountingPeriodStart = moment(this.accountingPeriod.end)
                    .add(1, "days")
                    .startOf("day")
                    .format("YYYY-MM-DD");
                if (this.accountingPeriods?.length) {
                    this.nextAccountingPeriod = this.accountingPeriods.find((ap) =>
                        ap.start.startsWith(nextAccountingPeriodStart),
                    );

                    if (this.nextAccountingPeriod && this.nextAccountingPeriod.id) {
                        this.periods.push({
                            period: "N+1",
                            id: this.nextAccountingPeriod.id,
                            onQueryDone: (data) => {
                                this.onQueryDone411NLNextPeriod(data);
                            },
                            onQueryDone2: (data) => {
                                this.onQueryDone471NLNextPeriod(data);
                            },
                        });
                    }
                }
            } else {
                this.manualSelectedDate = this.formatDatePicker(moment().startOf("day").format());
            }
        }

        const closedPeriodEnds = [];
        let sortClosedPeriodEnd = [];
        let lastClosedPeriodEnd = "";

        for (const ap of this.accountingPeriods) {
            if (ap.closed === true) {
                closedPeriodEnds.push(ap.end);
            }
        }
        if (closedPeriodEnds.length === 1) {
            lastClosedPeriodEnd = closedPeriodEnds[0];
        } else if (closedPeriodEnds.length > 1) {
            sortClosedPeriodEnd = closedPeriodEnds.sort((a, b) => {
                if (a.end < b.end) return -1;
                if (a.end > b.end) return 1;
                return 0;
            });
            lastClosedPeriodEnd = sortClosedPeriodEnd[sortClosedPeriodEnd.length - 1];
            this.firstOpenPeriodStart = moment(lastClosedPeriodEnd).add(1, "days").format();
        }
        // ** this.minDate - dialog datepickeer
        if (lastClosedPeriodEnd) {
            this.firstOpenPeriodStart = moment(lastClosedPeriodEnd).add(1, "days").format();
        } else {
            this.firstOpenPeriodStart = moment(this.accountingPeriods[0].start).format();
        }

        // ** this.maxDate - dialog datepickeer
        if (
            lastClosedPeriodEnd &&
            lastClosedPeriodEnd < this.accountingPeriods[this.accountingPeriods.length - 1].end
        ) {
            this.lastOpenPeriodEnd = moment(
                this.accountingPeriods[this.accountingPeriods.length - 1].end,
            ).format();
        } else {
            this.lastOpenPeriodEnd = moment(
                this.accountingPeriods[this.accountingPeriods.length - 1].end,
            ).format();
        }
    }

    // ***********************************************************
    // ********** APOLLO - errMessages - customers - globalAmounts ***
    @Apollo({
        query: AUDIT_ITEMS,
        variables() {
            return {
                companyId: this.companyId,
                auditCheck: "checkReceivablesAgeing",
                auditCheckKey: this.acKey,
                accountingPeriodId: this.accountingPeriodId || undefined,
                // ERIC DATE TO CHECK BY MONICA
                date_lte: this.selectedDate
                    ? getDBFormattedEndDate(this.selectedDate)
                    : getDBFormattedEndDate(moment()),
            };
        },
        skip() {
            return !this.companyId || !this.accountingPeriodId;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading && data) {
                this.dataLoading = true;
                if (data?.auditItems?.items?.[0]) {
                    this.deleteAuditCheckResultDialog = false;
                    this.deleteAuditCheckResultLoading = false;

                    this.items = cloneDeep(data.auditItems.items[0]);

                    if (this.items) {
                        this.company = this.items.company;
                        this.globalAmounts = this.items.output.resume;

                        if (this.items.output?.customers && !isEmpty(this.items.output.customers)) {
                            this.customers = Object.values(this.items.output.customers);

                            if (this.items.output?.doubtfullAccountsHeaders) {
                                this.doubtfullAccountsHeaders = Object.values(
                                    this.items.output.doubtfullAccountsHeaders,
                                );
                                // console.log("Jallapeños");
                                // console.log(this.doubtfullAccountsHeaders);
                                this.doubtfullAccountsHeaders.forEach((element) => {
                                    element.title = element.text;
                                });
                                // console.log("Jallapeños");
                                // console.log(this.doubtfullAccountsHeaders);
                            } else {
                                this.doubtfullAccountsHeaders = [];
                            }

                            if (this.items.output?.resume) {
                                this.globalAmounts = this.items.output.resume;

                                if (!this.manualSelectedDate && this.globalAmounts.resumeDate) {
                                    this.manualSelectedDate = this.formatDatePicker(
                                        this.globalAmounts.resumeDate,
                                    );
                                }

                                this.ttcGlobalAmount =
                                    this.globalAmounts.importFECAmountSignedTotal +
                                    this.globalAmounts.bankTransactionsAmountSignedTotal +
                                    this.globalAmounts.more411AlsAmountSignedTotal;
                            } else {
                                this.globalAmounts = {};
                                this.ttcGlobalAmount = 0;
                            }
                        } else {
                            this.customers = [];
                            this.doubtfullAccountsHeaders = [];
                            this.globalAmounts = {};
                            this.ttcGlobalAmount = 0;
                        }

                        if (this.items.auditCheckResult?.id) {
                            this.auditCheckResult = this.items.auditCheckResult;
                            this.auditCheckResultId = this.items.auditCheckResult.id;

                            if (this.auditCheckResult.documents) {
                                this.connectedDocuments = this.auditCheckResult.documents;
                            }

                            if (this.auditCheckResult.reviewed) {
                                this.reviewed = this.auditCheckResult.reviewed;
                            }

                            if (this.auditCheckResult.results) {
                                this.results = this.auditCheckResult.results;
                            }

                            this.aaData = this.items.auditCheckResult.data?.[0] || undefined;
                            if (this.aaData) {
                                this.comment = this.aaData.comment || "";
                                this.shortComment = this.aaData.shortComment || "";
                                this.validated = this.aaData.validated || false;
                            }
                        } else {
                            this.auditCheckResultId = "";
                            this.comment = "";
                            this.shortComment = "";
                            this.validated = false;
                        }

                        // ** GeneralLedger - accountableAccounts
                        if (this.items?.item?.accountableAccounts?.length) {
                            this.accountableAccounts = this.items.item.accountableAccounts;
                        }
                    }
                } else {
                    this.items = {};
                }
                this.dataLoading = false;
            }
        },
    })
    items: any = {};

    customers: Array<any> = [];

    doubtfullAccountsHeaders: Array<any> = [];

    globalAmounts: any = {};

    ttcGlobalAmount: number = 0;

    accountableAccounts: any = [];

    aaData: Array<any> = [];

    reviewed: number = 0;

    get filteredThirdPartyCompanies() {
        if (this.inFilteredThirdPartyCompanies) {
            const customers = [];
            for (const customer of this.customers) {
                if (
                    this.inFilteredThirdPartyCompanies.find(
                        (fc) => fc.name === customer.customer.name,
                    )
                ) {
                    customers.push(customer);
                }
            }
            return customers;
        }
        return this.customers;
    }

    async fetchTotals(detailledBalanceInfos) {
        if (this.accountableAccounts.length) {
            if (
                detailledBalanceInfos &&
                Object.keys(detailledBalanceInfos).length &&
                detailledBalanceInfos.aaName
            ) {
                const foundedAA = this.accountableAccounts.find(
                    (aa) => aa.name === detailledBalanceInfos.aaName,
                );
                if (foundedAA) {
                    const indexFoundedAA = this.accountableAccounts.indexOf(foundedAA);

                    this.accountableAccounts[indexFoundedAA].queryLength =
                        detailledBalanceInfos.queryLength;

                    this.accountableAccounts[indexFoundedAA].aaName = detailledBalanceInfos.aaName;

                    this.accountableAccounts[indexFoundedAA].totalBalance =
                        detailledBalanceInfos.totalBalance;
                }

                // eslint-disable-next-line no-prototype-builtins
                const allFetchsDone = this.accountableAccounts.every((accAccount) =>
                    accAccount.hasOwnProperty("queryLength"),
                );

                if (allFetchsDone) {
                    // *** if any lines received
                    const noQueryLengths = !this.accountableAccounts.some(
                        (accAccount) => accAccount.queryLength > 0,
                    );
                    if (noQueryLengths) {
                        this.noResults = true;
                    } else if (!this.auditCheckResultId) {
                        this.createAdjustmentsData();
                    }
                }
            }
        } else {
            debugger; // git-ignore
        }
    }

    // ****** TABLE : PERIOD'S DOCUMENTS - checkBox Array *******
    selectedInvoices: Array<any> = [];
    singleSelect: Boolean = true;

    // **************** TABLE : PERIOD'S DOCUMENTS *****************
    periodDocuments: Array<any> = [];
    selectedPeriod: string = "";
    periodsCustomer: any = {};
    provisionCustomer: any = {};
    unrecoverableLossCustomer: any = {};
    creditNotesCustomer: any = {};

    async openPeriodALs(ALs, title, customer) {
        if (this.selectedPeriod === title && this.periodsCustomer === customer) {
            this.expand = !this.expand;
        } else {
            this.selectedPeriod = title;
            this.periodsCustomer = customer;

            if (ALs?.length) {
                this.periodDocuments = ALs;
            }

            this.expand = true;
            this.selectedInvoices = [];
        }
    }

    // **************** TABLE : creditNotes *****************
    async openCreditNotesList(data, customer) {
        if (this.creditNotesCustomer === customer) {
            this.expand4 = !this.expand4;
        } else {
            this.creditNotesCustomer = customer;
            if (this.customers.length > 0) {
                if (data) {
                    this.existingCreditNotes = data;
                }
            }
            this.expand4 = true;
        }
    }

    // **************** ICON : DOCUMENT VIEW *****************
    openObject(documentId, objectType) {
        if (objectType === "document") {
            this.$router.push({
                name: "document",
                params: {
                    companyId: this.companyId,
                    id: documentId,
                },
            });
        } else if (objectType === "bankTransaction") {
            this.$router.push({
                name: "reconciliation",
                params: {
                    companyId: this.companyId,
                    bankTransactionId: documentId,
                },
            });
        } else {
            debugger; // git-ignore
        }
    }

    deleteAcrDone() {
        this.deleteAuditCheckResultLoading = false;
        this.deleteAuditCheckResultDialog = false;
        this.refresh();
    }

    // ************ V-WINDOW **************
    step: number = 1;

    // ++++++++++++++ UPSERT +++++++++++++++
    async createAdjustmentsData(action = undefined) {
        const data = [
            {
                comment: this.comment || "",
                shortComment: this.shortComment || "",
                validated: this.validated || false,
            },
        ];

        let auditCheckResultVariables: any = {};

        if (this.acKey && this.companyId && this.accountingPeriodId) {
            auditCheckResultVariables = {
                id:
                    this.auditCheckResultId && this.auditCheckResultId.length
                        ? this.auditCheckResultId
                        : "",
                key: this.acKey + "_" + this.companyId + "_" + this.accountingPeriodId,
                companyId: this.companyId,
                status: this.validated ? "VALIDATED" : "EDITION",
                // thirdPartyCompanyCreate: this.selectedCustomer && this.selectedCustomer.id ? { connect: { id: this.selectedCustomer.id } } : undefined,
                // thirdPartyCompanyUpdate: this.selectedCustomer && this.selectedCustomer.id ? { connect: { id: this.selectedCustomer.id } } : undefined,
                accountingPeriodCreate: this.accountingPeriodId
                    ? { connect: { id: this.accountingPeriodId } }
                    : undefined,
                accountingPeriodUpdate: this.accountingPeriodId
                    ? { connect: { id: this.accountingPeriodId } }
                    : undefined,
                data: JSON.parse(JSON.stringify(data)) || [],
                auditCheckKey: this.acKey,
                type: "IN_AUDIT_REPORT",
                reviewed: this.reviewed,
            };
        }
        if (auditCheckResultVariables) {
            await this.$apollo.mutate({
                mutation: UPSERT_AUDIT_CHECK_RESULT,
                variables: auditCheckResultVariables,
            });
        }

        // await this.createUserActivity(action) // deprecated

        // ++++++++++++++ RESET +++++++++++++++++++
        this.refresh();
    }

    async refresh() {
        if (this.$apollo.queries && this.$apollo.queries.items) {
            this.$apollo.queries.items.refetch();
        } else {
            debugger; // git-ignore
        }

        this.refreshGeneralLedger471++;
        this.refreshGeneralLedger411++;

        if (this.accountableAccounts.length) {
            for (const aa of this.accountableAccounts) {
                await this.fetchTotals(aa.detailledBalanceInfos);
            }
        }

        this.initialiseCompany();
    }

    upsertedACR() {
        this.refresh();
    }

    unlinkDocument(id) {
        this.connectedDocuments = this.connectedDocuments.filter((document) => document.id !== id);
    }

    showLinkedDocument(id) {
        this.documentToDisplay = { id };
        this.alreadyLinkedDoc = true;
        this.dialogAuditCheckDocumentsManager = true;
    }

    async validateFunction() {
        if (!this.validated) {
            this.validated = !this.validated;
            await this.createAdjustmentsData("VALIDATE");
        } else {
            this.validated = !this.validated;
            this.reviewed = 0;
            await this.createAdjustmentsData("UPDATE");
        }
    }

    async previous(stepNumber) {
        this.step -= stepNumber;
    }

    async next(stepNumber) {
        this.step += stepNumber;
    }

    onQueryDone411NL(data) {
        if (data.generalLedger?.length) {
            this.totalBalance411NL = data.total411Balance;
            // this.cardCols411[1].nestedRows[0].nestedCols[1].content = this.totalBalance411NL || 0;
            this.show411NL = true;
        } else {
            this.show411NL = false;
        }
    }

    onQueryDone411NLNextPeriod(data) {
        if (data.generalLedger?.length) {
            this.totalBalance411NLNextPeriod = data.total411Balance;
            // this.cardCols411[2].nestedRows[0].nestedCols[1].content = this.totalBalance411NLNextPeriod || 0;
            this.show411NLNextPeriod = true;
        } else {
            this.show411NLNextPeriod = false;
        }
    }

    onQueryDone471NL(data) {
        if (data.generalLedger?.length) {
            this.totalBalance471NL = mathFix(data.totalBalance, 2) || 0;
            this.show471NL = true;
        } else {
            this.totalBalance471NL = 0;
            this.show471NL = false;
        }
    }

    onQueryDone471NLNextPeriod(data) {
        if (data.generalLedger?.length) {
            this.totalBalance471NLNextPeriod = mathFix(data.totalBalance, 2) || 0;
            this.show471NLNextPeriod = true;
        } else {
            this.totalBalance471NLNextPeriod = 0;
            this.show471NLNextPeriod = false;
        }
    }

    aaExpand(accountableAccount) {
        accountableAccount.expand = !accountableAccount.expand;
    }

    sumsTable(key) {
        // sum data in give key (property)
        const sumSigned = this.customers.reduce((a, b) => a + (b[key] || 0), 0);
        return sumSigned;
    }

    sumsTable2(key1, key2) {
        // sum data in give key (property)
        const sumSigned = this.customers.reduce((a, b) => a + (b[key1]?.[key2] || 0), 0);
        return sumSigned;
    }

    get closedPeriod() {
        if (this.accountingPeriod) {
            return closedPeriod(this.accountingPeriod);
        }
        return undefined;
    }

    initialiseCompany() {
        // this.accountingPeriod = null
        // this.company = null
        // this.firstOpenPeriodStart = ""
        // this.lastOpenPeriodEnd = ""

        // this.auditCheckResult = {}
        // this.currentDocACRid = ""
        // this.previousDocumentsIds = []
        // this.resultDocumentIdsToDelete = []

        this.shortComment = "";
        this.comment = "";

        // ** generalLedger
        // this.totalBalance411NL = 0;
        // this.totalBalance411NLNextPeriod = 0;
        // this.totalBalance471NL = 0;
        // this.totalBalance471NLNextPeriod = 0;

        this.creditNoteDialog = false;
        // this.selectedCustomer = {}

        this.minDate = "";
        this.maxDate = "";
        this.creditNote = {};
        this.creditNotes = [];
        this.existingCreditNotes = [];

        this.globalCreditNoteNetAmount = 0.0;
        this.globalCreditNoteVatAmount = 0.0;
        this.globalCreditNoteVatRate = 0.0;
        this.calculatedVatRate = 0.0;
        this.globalCreditNoteGrossAmount = 0.0;

        this.invoiceNumber = "";
        this.selectedInvoices = [];
        this.singleSelect = true;
        this.periodDocuments = [];
        this.selectedPeriod = "";
        this.periodsCustomer = {};
        this.provisionCustomer = {};
        this.unrecoverableLossCustomer = {};
        this.creditNotesCustomer = {};

        this.step = 1;
    }

    colorStyle(value, color) {
        if (value) {
            return `color: ${color}`;
        }
        return "";
    }

    colorStyleCustomer(customer, color) {
        if (
            customer.notReconciliatedBankTransactionsAmountSigned ||
            customer.notReconciliatedImportFECAmountSigned ||
            customer.more411AlsAmountSigned
        ) {
            return `color: ${color}`;
        }
        return "";
    }

    get barChartDataLabels() {
        return this.doubtfullAccountsHeaders.slice(2);
    }

    get barChartDataLabelsKeys() {
        return this.barChartDataLabels.map((x) => x.value);
    }

    get barChartDataLabelsNames() {
        return this.barChartDataLabels.map((x) => x.text);
    }

    get barChartRawData() {
        const temp = this.barChartDataLabelsKeys.map((key) =>
            this.filteredThirdPartyCompanies.reduce(
                (total, cmp) => total + (cmp?.[key]?.grossAmountSigned ?? 0),
                0,
            ),
        );
        return temp;
    }

    get formattedBarChartData() {
        // const davaValues = values.map(val => val.value[dataType])
        const barDatasets = [
            {
                label: "Montant",
                data: this.barChartRawData,
            },
        ];
        chartColors("bar", barDatasets, "cool");
        const barData = {
            labels: this.barChartDataLabelsNames,
            datasets: barDatasets,
        };
        return barData;
    }

    get barChartOptions() {
        const self = this;

        return {
            responsive: true,
            plugins: {
                legend: {
                    display: false,
                    position: "bottom",
                },
                tooltip: {
                    mode: "index",
                    position: "average",
                    callbacks: {
                        label: function (tooltipItem): string | string[] {
                            let label = self.newCommonFormatCurrency(tooltipItem.raw) || "";
                            return label;
                        },
                    },
                },
            },
            scales: {
                y: {
                    // stacked: true,
                    // min:0,
                    beginAtZero: true,
                    // stepSize: 1
                },
                x: {
                    // stacked: true,
                    // min:0,
                    beginAtZero: true,
                },
            },
            maintainAspectRatio: false,
        };
    }

    // /////// TODO : test d'Eric pour voir si le query est appelé //////////////
    // testQueryDone(period, data) {
    //     debugger
    //     period.onQueryDone(data)
    // }
    // ///////////////////////////////////////////////////////
}

export default toNative(CheckReceivablesAgeing);
</script>
